"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./H1.css");
require("./H1.tablet.css");
require("./H1.desktop.css");
require("./H1.css");
var H1 = /** @class */ (function (_super) {
    __extends(H1, _super);
    function H1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    H1.prototype.getClasses = function () {
        var style = [styles.h1];
        if (this.props.options.className && this.props.options.className.length > 0) {
            style.push(this.props.options.className);
        }
        if (this.props.options && this.props.options.alternate) {
            style.push(styles.alternate);
        }
        return style.join(' ');
    };
    H1.prototype.getAccessibility = function () {
        return Object.assign({
            'aria-level': 1,
        });
    };
    H1.prototype.render = function () {
        var role = this.props.options && this.props.options.role ? this.props.options.role : 'heading';
        return (React.createElement("h1", __assign({ "data-test-id": this.props.testId, className: this.getClasses(), role: role }, this.getAccessibility()), this.props.data.text));
    };
    H1.defaultProps = {
        options: {
            className: '',
        },
    };
    return H1;
}(React.Component));
exports.default = H1;
//# sourceMappingURL=H1.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/typography/H1/H1.js
// module id = 1351
// module chunks = 8